module.exports = __webpack_public_path__ + "officialStatic/img/studentD.f7be449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/studentD.png
// module id = i/W+
// module chunks = 0